/* eslint-disable no-console */
import { useEffect } from 'react';
import { useCreateLead, useUpdateLead } from '../../query';
import { useProfileContext } from '../profile';
import { Result, Profile } from '../types';
import { getSavedEmail, mapLiquidAssetsGraph } from '../../helpers';

const useCreateOrUpdateLeadResult = (
  leadRequest: any,
  leadResult: Partial<Result> | null,
  onSucces: (leadResult: Partial<Result>) => void,
) => {
  const {
    createLead,
    isLoading: isLoadingCreateLead,
    error: errorCreateLead,
  } = useCreateLead();
  const {
    updateLead,
    isLoading: isLoadingUpdateLead,
    error: errorUpdateLead,
  } = useUpdateLead();
  const { useProfile, onChange } = useProfileContext();
  const profile = useProfile<Profile>();

  useEffect(() => {
    const savedEmail = getSavedEmail();

    const createOrUpdateLeadResult = async () => {
      let leadResponse = null;
      const chosenEmail = profile.who.email || profile.contact.email;

      if (leadResult?.isDirty && savedEmail === chosenEmail) {
        leadResponse = await updateLead(leadRequest);
      } else if (!leadResult || savedEmail !== chosenEmail) {
        leadResponse = await createLead(leadRequest);
      }
      if (leadResponse?.leadResult != null) {
        leadResponse.leadResult = {
          ...leadResponse.leadResult,
          liquidAssetsGraph: mapLiquidAssetsGraph(
            leadResponse.leadResult.liquidAssetsGraph,
          ),
        };

        onSucces({ ...leadResponse.leadResult, isDirty: false });
      }
    };

    createOrUpdateLeadResult();
  }, []);

  return {
    isLoading: isLoadingCreateLead || isLoadingUpdateLead,
    error: errorCreateLead || errorUpdateLead,
  };
};

export default useCreateOrUpdateLeadResult;
